import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { DoctorsStationChangePasswordSentComponent } from './doctors-station-change-password-sent/doctors-station-change-password-sent.component';
import { DoctorsStationForgotPasswordComponent } from './doctors-station-forgot-password/doctors-station-forgot-password.component';
import { DoctorsStationInputComponent } from './doctors-station-input/doctors-station-input.component';
import { DoctorsStationLoginComponent } from './doctors-station-login/doctors-station-login.component';
import { DoctorsStationOemHeaderComponent } from './doctors-station-oem-header/doctors-station-oem-header.component';
import { DoctorsStationOemLoginMessageComponent } from './doctors-station-oem-login-message/doctors-station-oem-login-message.component';
import { DoctorsStationOemRegisterMessageComponent } from './doctors-station-oem-register-message/doctors-station-oem-register-message.component';
import { DoctorsStationPasswordInputComponent } from './doctors-station-password-input/doctors-station-password-input.component';
import { DoctorsStationRegisterResendComponent } from './doctors-station-register-resend/doctors-station-register-resend.component';
import { DoctorsStationRegisterSendComponent } from './doctors-station-register-send/doctors-station-register-send.component';
import { DoctorsStationRegisterComponent } from './doctors-station-register/doctors-station-register.component';
import { DoctorsStationResetPasswordComponent } from './doctors-station-reset-password/doctors-station-reset-password.component';
import { DoctorsStationUnblockComponent } from './doctors-station-unblock/doctors-station-unblock.component';
import { DoctorsStationComponent } from './doctors-station/doctors-station.component';
import { OemService } from './oem.service';

@NgModule({
  declarations: [
    DoctorsStationComponent,
    DoctorsStationLoginComponent,
    DoctorsStationRegisterComponent,
    DoctorsStationUnblockComponent,
    DoctorsStationRegisterResendComponent,
    DoctorsStationRegisterSendComponent,
    DoctorsStationForgotPasswordComponent,
    DoctorsStationResetPasswordComponent,
    DoctorsStationChangePasswordSentComponent,
    DoctorsStationInputComponent,
    DoctorsStationPasswordInputComponent,
    DoctorsStationOemHeaderComponent,
    DoctorsStationOemRegisterMessageComponent,
    DoctorsStationOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    DoctorsStationResetPasswordComponent,
    DoctorsStationComponent,
    DoctorsStationRegisterResendComponent,
    DoctorsStationRegisterSendComponent,
    DoctorsStationUnblockComponent,
    DoctorsStationChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DoctorsStationModule { }
